import React, { useState, useEffect, useRef, FC  } from 'react';
import kemtapi from '@kemtai/skeleton-api';
import { Keypoints } from  '@kemtai/skeleton-api';
import './style.css'
import {drawSkeleton} from './Visualize'
//import DiamondSkeleton from './DiamondSkeleton';
import CameraRecorder from './CameraRecorder';
import { SitToStandLogic } from './Logic';
import { initialTugState, TugState } from './types';


const cameraRecorder = new CameraRecorder("skeleton-dev-tool");
//const diamondSkeleton = new DiamondSkeleton()
const logic = new SitToStandLogic();

function RedCircle() {
    return (
        <div className='recording'>        
            <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="25" fill="red" />
            </svg>
        </div>
    )
}



export type SkeletonProps = {
    videoSource? : string
}

export const Skeleton : FC<SkeletonProps>  = ({ videoSource : _videoSource = "camera" }) => {
  const canvasRef = useRef<HTMLCanvasElement|null>(null);
  const [recording, setRecording] = useState<boolean>(false);
  const [videoSource, setVideoSource] = useState<string>(_videoSource);
  const [tugState, setTugState] = useState<TugState>(initialTugState());


  const reset = () => {
        logic.reset();
        setTugState(initialTugState());
  }  

  const selectVideoSource = async (source:string) => {

    setVideoSource(source);
    if (source=== "camera") {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
          kemtapi.setInputVideoStream(stream)
    } else {
        kemtapi.camera.setDebugVideo("https://app.kemtai.com/media/exercises/ad2e3321-81ce-5ae8-84bf-628149833cb1/640x480.mp4");
    }
  }

   const init = async () => {      
        await selectVideoSource(videoSource)
        await kemtapi.loadModels()
        const disposer = kemtapi.registerFrameSkeletonCallback(updateSkeleton, "DrawSkeleton");
        return () => {
            disposer();
        }
   }

  useEffect(() => {
    init();    
  }, []);

  useEffect(() => {
    if (recording) {
        const stream = kemtapi.getStream()
        if (!stream) {
            console.log("No stream available for recording");
            setRecording(false);
            return;
        }
        cameraRecorder.start(stream);
    } else {
        cameraRecorder.stop();
    }
  }, [recording]);


//   useEffect(() => {
//     if (canvasRef.current) {
//         const ctx = canvasRef.current.getContext('2d');
//         if (ctx) {
//             diamondSkeleton.setContext(ctx);
//         }
//     }
//   },[canvasRef.current])


  const updateSkeleton = (kp:Keypoints|null, img : ImageBitmap|ImageData|null) => {
    if (kp) {
        setTugState(logic.processFrame(kp));
    }
    if (canvasRef.current ) {
       drawSkeleton(canvasRef.current, kp, img);       
       //diamondSkeleton.update(kp);
       
    }
  }


  return (
    <div className="container">
        <div style={{position: 'relative'}}>
            <canvas  ref={canvasRef} height={480} width={640}></canvas>
            {recording && <RedCircle/>}
        </div>
         {/* <div className='right-pannel'>  
                            
        </div>  */}
        {tugState.popupMessage && <div className='popup-message'>
            <p>{tugState.popupMessage}</p>
            {/* <h1>view: {tugState.viewType && tugState.viewType}</h1>
            <h1>userPosition: {tugState.userPosition && tugState.userPosition}</h1>
            <h1>state:{tugState.state && tugState.state}</h1>
            <h1>{tugState.measuring && <>Measuring .... {(tugState.duration!/1000).toFixed(1)}</>}</h1>
            <h1>{tugState.result && <>TUG time {(tugState.result!/1000).toFixed(1)}</>}</h1> */}

        </div>}
        {tugState.result && <div className='result-modal'>
            <div className='result-content'>
                <p>Timed Up and Go</p>
                <h2> {(tugState.result!/1000).toFixed(1)} seconds. </h2>
                <button onClick={reset}>Close</button>
            </div>
        </div>}

    </div>   
  );

}